module.exports = __webpack_public_path__ + "static/img/slide1_ban.5bf20f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/slide1_ban.png
// module id = mqcx
// module chunks = 1